import { EntityState } from '@ngrx/entity';
import { Question } from '@app/resources/services';

export interface QuestionState extends EntityState<Question> {
  selectedQuestionId: number;
  hasLoaded: boolean;
}
